export const TRANSACTION_DETAIL_STALE_TIME = 5 * 60_000;
export const TRANSACTION_LIST_STALE_TIME = 1 * 60_000;

export const TRANSACTION_STATUS_COLORS: Record<string, string> = {
  VALIDATED: '#22c55e',
  RECEIVED: '#3b82f6',
  PENDING: '#f59e0b',
  PAID: '#8b5cf6',
  DENIED: '#ef4444',
  DELETED: '#94a3b8',
};
